import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/images/Kyzylorda.png'
import _imports_1 from '@/assets/images/aqmola1.jpg'
import _imports_2 from '@/assets/images/aqmola2.jpg'
import _imports_3 from '@/assets/images/aqmola3.jpg'
import _imports_4 from '@/assets/images/aqmola4.jpg'
import _imports_5 from '@/assets/images/aqmola5.jpg'


const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "container-fluid intro" }, [
  /*#__PURE__*/_createVNode("div", { class: "row" }, [
    /*#__PURE__*/_createVNode("div", { class: "col-12 col-sm-7" }, [
      /*#__PURE__*/_createVNode("div", { class: "left-region-image" }, [
        /*#__PURE__*/_createVNode("img", { src: _imports_0 })
      ])
    ]),
    /*#__PURE__*/_createVNode("div", { class: "col-12 col-sm-5" }, [
      /*#__PURE__*/_createVNode("h2", { class: "right-region-paragraf" }, "Кызылординская область"),
      /*#__PURE__*/_createVNode("div", { class: "left-region-text" }, " Кызылординская область – уникальная туристическая дестинация. Здесь расположен крупнейший в мире космодром Байконур, который привлекает к себе и местных, и иностранных туристов. Кстати, расположенный рядом город с одноименным названием – единственный населенный пункт в Казахстане, на территории которого действует не только местное, но и российское законодательство, а при торговых расчетах используется российская валюта. Организация туров на космодром – одно из перспективных туристических направлений области. ")
    ])
  ])
], -1)
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "container" }, [
  /*#__PURE__*/_createVNode("div", { class: "row-2" }, [
    /*#__PURE__*/_createVNode("div", { class: "col" }, [
      /*#__PURE__*/_createVNode("div", { class: "region-way-paragraf" }, "«Космические» Экскурсии")
    ]),
    /*#__PURE__*/_createVNode("div", { class: "col" }, [
      /*#__PURE__*/_createVNode("div", { class: "region-way-text" }, [
        /*#__PURE__*/_createTextVNode(" Туры на "),
        /*#__PURE__*/_createVNode("b", null, "Байконур"),
        /*#__PURE__*/_createTextVNode(" по популярности несомненно являются лидирующими. Сюда отправляются как с целью посмотреть запуск пилотируемого или непилотируемого космического аппарата, так и в межполетные периоды. У гостей космодрома есть возможность осмотреть его основные комплексы, посетить местный музей и "),
        /*#__PURE__*/_createVNode("b", null, "Международную космическую школу"),
        /*#__PURE__*/_createTextVNode(". Все гости Байконура с удовольствием посещают сувенирный рынок, чтобы приобрести подарки в память о поездке. ")
      ])
    ])
  ])
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "container" }, [
  /*#__PURE__*/_createVNode("div", { class: "row" }, [
    /*#__PURE__*/_createVNode("div", { class: "col" }, [
      /*#__PURE__*/_createVNode("div", { class: "region-table" }, [
        /*#__PURE__*/_createVNode("table", { id: "city-table" }, [
          /*#__PURE__*/_createVNode("tr", null, [
            /*#__PURE__*/_createVNode("th", null, " Единовременная вместимость (койко-мест) мест размещения, шт "),
            /*#__PURE__*/_createVNode("td", null, "3378")
          ]),
          /*#__PURE__*/_createVNode("tr", null, [
            /*#__PURE__*/_createVNode("th", null, "Заполняемость гостиниц (койко-мест), %"),
            /*#__PURE__*/_createVNode("td", null, "13,3")
          ]),
          /*#__PURE__*/_createVNode("tr", null, [
            /*#__PURE__*/_createVNode("th", null, " Обслужено посетителей местами размещения по внутреннему туризму (резиденты), чел "),
            /*#__PURE__*/_createVNode("td", null, "52527")
          ]),
          /*#__PURE__*/_createVNode("tr", null, [
            /*#__PURE__*/_createVNode("th", null, " Обслужено посетителей местами размещения по въездному туризму (нерезиденты). чел "),
            /*#__PURE__*/_createVNode("td", null, "2074")
          ])
        ])
      ])
    ])
  ])
], -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "container" }, [
  /*#__PURE__*/_createVNode("div", { class: "row-2" }, [
    /*#__PURE__*/_createVNode("div", { class: "col" }, [
      /*#__PURE__*/_createVNode("div", { class: "region-way-paragraf" }, "Другие Направления Отдыха")
    ]),
    /*#__PURE__*/_createVNode("div", { class: "col" }, [
      /*#__PURE__*/_createVNode("div", { class: "region-way-text" }, [
        /*#__PURE__*/_createVNode("p", null, [
          /*#__PURE__*/_createTextVNode(" Если туры на космодром интересуют практически всех, то иные направления отдыха более популярны среди местных жителей. Внутренний туризм (статистика последних лет) – это «зеленые» экскурсии. Полюбоваться красотами природы в Кызылординской области можно вдоль извилистого русла "),
          /*#__PURE__*/_createVNode("b", null, "Сырдарьи"),
          /*#__PURE__*/_createTextVNode(", на "),
          /*#__PURE__*/_createVNode("b", null, "Жаксыкылыше, Арыси"),
          /*#__PURE__*/_createTextVNode(" и других соленых озерах. Любителям экстрима можно порекомендовать проехаться по дну практически высохшего "),
          /*#__PURE__*/_createVNode("b", null, "Аральского моря"),
          /*#__PURE__*/_createTextVNode(". Поправить здоровье лучше отправиться на лечебные грязи озера "),
          /*#__PURE__*/_createVNode("b", null, "Терескен"),
          /*#__PURE__*/_createTextVNode(". Значительная часть территории области занята пустынями, куда отправляются на фотосафари, чтобы наблюдать за лисицами-корсаками, сайгаками и другими животными в их естественной среде обитания. ")
        ]),
        /*#__PURE__*/_createVNode("p", null, [
          /*#__PURE__*/_createTextVNode(" Интересны путешественникам и исторические экскурсии. Самые популярные сегодня маршруты – к мемориальном комплексу поэта-песенника и композитора IX века – "),
          /*#__PURE__*/_createVNode("b", null, "Коркыт-ата"),
          /*#__PURE__*/_createTextVNode(", к руинам древних городищ и ставок степных ханов "),
          /*#__PURE__*/_createVNode("b", null, "Дженду, Сыганаку, Жанкенту"),
          /*#__PURE__*/_createTextVNode(" и других. ")
        ])
      ])
    ])
  ])
], -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "container" }, [
  /*#__PURE__*/_createVNode("div", { class: "row-2" }, [
    /*#__PURE__*/_createVNode("div", { class: "col" }, [
      /*#__PURE__*/_createVNode("div", { class: "region-way-paragraf" }, "Перспективы Отрасли")
    ]),
    /*#__PURE__*/_createVNode("div", { class: "col" }, [
      /*#__PURE__*/_createVNode("div", { class: "region-way-text" }, [
        /*#__PURE__*/_createVNode("p", null, " Как развивается туризм в Кызылординской области? Этот сегмент рынка в регионе достаточно перспективен. Уже сейчас под охрану государства в области взяты более полутысячи историко-культурных объектов. В рамках программы «Рухани жаңғыру» ведутся археологические изыскания, реставрационные работы. Как часть проекта «Цифровой Казахстан», была создана интерактивная карта туристических объектов, и на 150 из них установлены QR-коды с основной информацией о памятнике. ")
      ])
    ])
  ])
], -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "container" }, [
  /*#__PURE__*/_createVNode("div", { class: "row" }, [
    /*#__PURE__*/_createVNode("div", { class: "col" }, [
      /*#__PURE__*/_createVNode("h2", { class: "section__title" }, "ФОТОГАЛЕРЕЯ")
    ])
  ])
], -1)
const _hoisted_7 = { class: "container" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col" }
const _hoisted_10 = { class: "regio-swiper" }
const _hoisted_11 = /*#__PURE__*/_createVNode("img", {
  class: "region-photo",
  src: _imports_1
}, null, -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("img", {
  class: "region-photo",
  src: _imports_2
}, null, -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("img", {
  class: "region-photo",
  src: _imports_3
}, null, -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("img", {
  class: "region-photo",
  src: _imports_4
}, null, -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("img", {
  class: "region-photo",
  src: _imports_5
}, null, -1)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_adaptive_main_top_line = _resolveComponent("adaptive-main-top-line")
  const _component_swiper_slide = _resolveComponent("swiper-slide")
  const _component_swiper = _resolveComponent("swiper")
  const _component_Downloaded = _resolveComponent("Downloaded")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_adaptive_main_top_line),
    _hoisted_1,
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _hoisted_5,
    _hoisted_6,
    _createVNode("div", _hoisted_7, [
      _createVNode("div", _hoisted_8, [
        _createVNode("div", _hoisted_9, [
          _createVNode("div", _hoisted_10, [
            _createVNode(_component_swiper, {
              "slides-per-view": 1,
              "space-between": 40,
              loop: false,
              navigation: "",
              onSwiper: _ctx.onSwiper,
              onSlideChange: _ctx.onSlideChange
            }, {
              default: _withCtx(() => [
                _createVNode(_component_swiper_slide, null, {
                  default: _withCtx(() => [
                    _hoisted_11
                  ]),
                  _: 1
                }),
                _createVNode(_component_swiper_slide, null, {
                  default: _withCtx(() => [
                    _hoisted_12
                  ]),
                  _: 1
                }),
                _createVNode(_component_swiper_slide, null, {
                  default: _withCtx(() => [
                    _hoisted_13
                  ]),
                  _: 1
                }),
                _createVNode(_component_swiper_slide, null, {
                  default: _withCtx(() => [
                    _hoisted_14
                  ]),
                  _: 1
                }),
                _createVNode(_component_swiper_slide, null, {
                  default: _withCtx(() => [
                    _hoisted_15
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["onSwiper", "onSlideChange"])
          ])
        ])
      ])
    ]),
    (!_ctx.downloaded)
      ? (_openBlock(), _createBlock(_component_Downloaded, { key: 0 }))
      : _createCommentVNode("", true)
  ], 64 /* STABLE_FRAGMENT */))
}